export default __webpack_public_path__ + "static/media/artificial_intelligence.c61ec02f.png";